import { useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { defaultRoutes } from '../common/routerConfig';

/**
 * This function is used to check if a route's flags are active.
 * It accepts route's flags object and flags from useFlags() hook. Based on the condition, it will compare the flags and return true if the flag is active, false otherwise.
 *
 * @param {Object} flags - The flags object
 * @param {string} condition - The condition to check
 * @returns {boolean} - True if the flag is active, false otherwise
 */
function isRouteFlagsActive(routeFlags, flags, condition = 'OR') {
  if (Object.keys(routeFlags).length === 0) {
    return true;
  }
  if (condition === 'OR') {
    return Object.keys(routeFlags).some((flag) => {
      const expectedValue = routeFlags[flag];
      const currentValue = flags[flag];
      // For OR condition: include if any flag matches exactly
      return currentValue === expectedValue;
    });
  }
  // AND condition: all flags must match exactly
  return Object.keys(routeFlags).every((flag) => {
    const expectedValue = routeFlags[flag];
    const currentValue = flags[flag];
    return currentValue === expectedValue;
  });
}

/**
 * This hook is used to get the routes for the learn one application.
 * It is used to apply the feature flags to the routes.
 *
 * @returns {Array} - The routes for the learn one application.
 */
const useLearnOneRoutes = () => {
  const flags = useFlags();
  const [routes, setRoutes] = useState(defaultRoutes);

  useEffect(() => {
    setRoutes(defaultRoutes.filter((route) => isRouteFlagsActive(route?.flags?.values ?? {}, flags, route?.flags?.condition)));
  }, [flags]);

  return routes;
};

export default useLearnOneRoutes;
